export * from "./HttpClient";
export * from "./HttpException";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/http/index.js
// module id = 49
// module chunks = 1